import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastProvider } from "./components/shared/toastMessages/toastProvider";

// Main Components
import Landing from "./components/landing/landing";
import Portal from "./components/portal/portal";
import BackOffice from "./components/backOffice/backOffice";

//Landing
import Login from "./components/landing/pages/login/login";
import ResetPassword from "./components/landing/pages/resetPassword/resetPassword";
import UnlockAccount from "./components/landing/pages/unlockAccount/unlockAccount";
import ResendConfirmEmail from "./components/landing/pages/resendConfirmEmail/resendConfirmEmail";

//Portal
import Dashboard from "./components/portal/pages/dashboard/dashboard";
import EditUser from "./components/portal/pages/editUser/editUser";
import EditProfile from "./components/portal/pages/editProfile/editProfile";
import AddMailing from "./components/portal/pages/addMailing/addMailing";
import ManageMailing from "./components/portal/pages/manageMailing/manageMailing";
import ManageUsers from "./components/portal/pages/users/users";
import ManageEmails from "./components/portal/pages/manageEmails/manageEmails";
import CreateEmail from "./components/portal/pages/createEmails/createEmail";
import EditMalingList from "./components/portal/pages/editMailing/editMailing";
import ViewEmail from "./components/portal/pages/viewEmails/viewEmail";
import Settings from "./components/portal/pages/settings/settings";

//Back Office
import Home from "./components/backOffice/pages/home/home";
import ApiKeys from "./components/backOffice/pages/apiKeyManagement/apiKeys";
import Events from "./components/backOffice/pages/events/events";
import UserAudits from "./components/backOffice/pages/userAudits/userAudits";
import TennatSettings from "./components/backOffice/pages/tenantSettings/tennantSettings";
import ChangePassword from "./components/landing/pages/ChangePassword/ChangePassword";

function App() {
  return (
    <Router>
      <ToastProvider>
        <Routes>
          <Route path="/" element={<Landing />}>
            <Route path="/" element={<Login />} />
            <Route path="Account/ResetPassword" element={<ResetPassword />} />
            <Route path="Account/Unlock" element={<UnlockAccount />} />
            <Route path="Account/ResendConfirm" element={<ResendConfirmEmail />} />
            <Route path="ResetPassword/:token" element={<ChangePassword />} />
            <Route path="ConfirmAccount/:token" element={<ChangePassword />} />
            <Route path="Confirm/:token" element={<Dashboard />} />
            <Route path="*" element={<Navigate to="/" replace/>} />
            <Route path="" element={<Navigate to="/" replace />} />
          </Route>
          <Route path="Portal" element={<Portal />}>
            <Route path="Dashboard" element={<Dashboard />} />
            <Route path="Mailing/Add" element={<AddMailing />} />
            <Route path="Mailing/Edit/:id" element={<EditMalingList />} />
            <Route path="Mailing/Manage" element={<ManageMailing />} />
            <Route path="Emails/Create" element={<CreateEmail />} />
            <Route path="Emails/Edit/:id" element={<ViewEmail />} />
            <Route path="Emails/Manage" element={<ManageEmails />} />
            <Route path="Users/Manage" element={<ManageUsers />} />
            <Route path="Users/Edit/:id" element={<EditUser />} />
            <Route path="Profile" element={<EditProfile />} />
            <Route path="Settings" element={<Settings />} />
            <Route path="" element={<Navigate to="/Portal/Dashboard" replace />} />
            <Route path="*" element={<Navigate to="/Portal/Dashboard" replace />} />
          </Route>
          <Route path="BackOffice" element={<BackOffice />}>
            <Route index element={<Navigate to="Home" replace />} />
            <Route path="Home" element={<Home />} />
            <Route path="Keys" element={<ApiKeys />} />
            <Route path="Events" element={<Events/>} />
            <Route path="Audits" element={<UserAudits/>} />
            <Route path="Settings" element={<TennatSettings/>} />
            <Route path="*" element={<Navigate to="Home" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ ToastProvider>
    </Router>
  );
}

export default App;
